export default {
  backgroundImage: 'countdown_section_bg.png',
  eventStartTitle: 'Event starts in',
  eventEndTitle: 'Time left',
  nextEventStartTitle: 'QHack 2023 starts in',
  nextEventStartDateTime: 'Mon Feb 13 2023 14:00:00 GMT+0000', // Stick to GMT timestamp format
}
